import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./components/App";

import "./assets/styles/index.scss";

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require("./mocks/browser");
  worker.start({
    onUnhandledRequest: "bypass",
  });
}

ReactDOM.render(<App />, document.getElementById("root"));
